import { useEffect, useRef, useState } from "react";
import svgIcons from "../../../assets/svg/svgIcons";
import { TrainingVideo } from "../type";

const HelpFeaturesVideo = ({ videoData }: { videoData: TrainingVideo | undefined }) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const playVideo = videoData;
    const videoChapters = videoData?.video_chapters;
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);

    useEffect(() => {
        if (isVideoPlaying && videoRef.current) {
            const playPromise = videoRef.current.play();
            if (playPromise?.catch) {
                playPromise.catch(() => { });
            }
        }
    }, [isVideoPlaying, playVideo]);

    if(videoData)
    return (
        <>
            {!isVideoPlaying ? (
                // For video thumbail and play button
                <div className="relative w-full max-w-[850px] rounded-lg overflow-hidden aspect-video mb-10 justify-self-center">
                    <button
                        className="relative w-full h-full"
                        type="button"
                        key={playVideo?.id}
                        onClick={() => { setIsVideoPlaying(true); }}
                    >
                        <img
                            className="absolute inset-0 w-full h-full object-cover scale-105"
                            src={playVideo?.thumbnail}
                            alt={playVideo?.title}
                        />     
                        <span className="absolute top-0 left-0 w-full h-full z-10 rounded-lg px-4 py-3 flex flex-col bg-gradient-to-r from-black/40 to-accent-blue-bright/40">
                            <div className="relative w-full h-full">
                                <span className=" absolute  bottom-12 left-4 text-xs tracking-widest text-white text-left drop-shadow-md">GUIDED TUTORIAL</span>
                                <span className="absolute bottom-4 left-4 text-xl tracking-wider text-white text-left drop-shadow-md">Watch: {playVideo?.title}</span>
                                <span className="absolute bottom-4 right-4 text-xs text-white text-right drop-shadow-md">{playVideo?.duration}</span>
                            </div>
                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="bg-white rounded-xl w-16 h-16 flex items-center justify-center shadow-lg">
                                    <img
                                        src={svgIcons.PlayButton}
                                        alt="play"
                                        className="w-6 h-6"
                                    />
                                </div>
                            </div>
                        </span>
                    </button>
                </div>
            ) : (
                // Video player
                <div className="space-y-4">
                    <div className="relative w-full max-w-[850px] rounded-lg overflow-hidden aspect-video mb-7 justify-self-center">
                        <video
                            ref={videoRef}
                            className={`w-full h-full object-contain ${isVideoPlaying ? "opacity-100" : "opacity-0"
                                }`}
                            controls
                            playsInline
                            autoPlay
                            preload="auto"
                            key={playVideo?.id}
                        >
                            <source key={playVideo?.id} type="video/mp4" src={playVideo?.video} />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    {isVideoPlaying &&
                        (
                            <div className="flex mb-8 mx-2 max-w-[calc(100vw-8rem)] w-full flex-wrap pb-5 gap-2">
                                {videoChapters && videoChapters.map((chapter,index:number) => (
                                    <button
                                        key={index}
                                        className={
                                            `bg-accent-blue-paleO66 enabled:hover:bg-accent-blue-pale ` +
                                            `rounded-lg px-4 py-2 text-sm inline-flex gap-2 min-w-44`
                                        }
                                        onClick={() => {
                                            if (!!videoRef.current?.currentTime) {
                                                const timeParts = chapter.timestamp.split(':').map(Number);
                                                const seconds = timeParts[0] * 3600 + timeParts[1] * 60 + timeParts[2];
                                                videoRef.current.currentTime = seconds;
                                                videoRef.current.play();
                                            }
                                        }}
                                    >
                                        <span className="font-semibold text-accent-blue-dark">{chapter.timestamp}</span>
                                        <span className="overflow-hidden whitespace-nowrap text-ellipsis">{chapter.title}</span>
                                    </button>
                                ))}
                            </div>
                        )}
                </div>
            )}
        </>
    );
    else
    return(<></>);
};

export default HelpFeaturesVideo;